export default {
	name: 'Convention.Checkout.Notifications',
	path: 'convention/checkout/notifications',
	topLevel: true,
	meta: {
		auth: true,
		submenu: false,
		parents: ['Convention.Checkout.Notifications']
	},
	form: {
		component: 'ConventionCheckoutNotification',
		api: 'convention/checkout/notification',
		noun: 'game'
	}
}